import { throwError } from "@/lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import {
  PrintFormat,
  PrintFormatList,
  PrintFormatPayload,
} from "@/utils/types/printFormat";
import { PrintFormatPreviewPayload } from "@/utils/types/printFormatPreviewPayload";

const basePath = "/print_formats";

class PrintFormatService {
  getAllPrintFormats = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }): Promise<PrintFormatList> => {
    return await get<PrintFormatList>(`${basePath}/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getPrintFormatById = async (id: string): Promise<PrintFormat> => {
    if (!id) {
      throwError("ID is required", "PrintFormatService");
    }
    return await get<PrintFormat>(`${basePath}/${id}/`);
  };

  createPrintFormat = async (payload: PrintFormatPayload): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "PrintFormatService");
    }
    return await post(`${basePath}/`, payload);
  };

  updatePrintFormat = async (
    id: string,
    payload: PrintFormatPayload
  ): Promise<any> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "PrintFormatService");
    }
    return await put(`${basePath}/${id}/`, payload);
  };

  deletePrintFormat = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "PrintFormatService");
    }
    return await del(`${basePath}/${id}/`);
  };

  previewPrintFormatHTML = async (
    payload: PrintFormatPreviewPayload
  ): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "PrintFormatService");
    }
    return await post("/print_formats/preview/", payload);
  };

  renderPrintFormatPDF = async (
    payload: PrintFormatPreviewPayload
  ): Promise<Blob> => {
    if (!payload) {
      throwError("Payload is required", "PrintFormatService");
    }
    return await post("/print_formats/render_pdf/", payload, {
      responseType: "blob",
    });
  };
}

const instance = new PrintFormatService();
export default instance;
